export const formDefault = {
  cod_cst_ibs_cbs: null,
  des_classif_trib: '',
  des_ibs_cbs: '',
  per_aliq_cbs: '',
  per_red_cbs: '',
  val_red_social: '',
};

export const modalCSTDefault = {
  des_cst_ibs_cbs: '',
  cst_ibs_cbs: '',
};

export const ufDefault = {
  des_sigla: null,
  per_aliq_ibs_est: '',
  per_aliq_ibs_mun: '',
  per_red_ibs: '',
};
